import ModelDetailsSection from './ModelDetailsSection';

export default ModelDetailsSection;
